import { IArea } from '../models/area';

const fixedDataAreas: Array<IArea> = [
  {
    "code": "sapporo_niseko_kiroro",
    "kml": null,
    "name_ja": "札幌・ニセコ・キロロ",
    "name_en": "Sapporo, Niseko, Kiroro",
    "name_zh_tw": "札幌、新雪谷、喜樂樂",
    "name_zh_hk": "札幌、新雪谷、KIRORO",
    "name_zh_cn": "札幌、二世谷、喜乐乐"
  },
  {
    "code": "furano_asahikawa_tomamu",
    "kml": null,
    "name_ja": "富良野・旭川・トマム",
    "name_en": "富良野・旭川・トマム",
    "name_zh_tw": "富良野、旭川、TOMAMU",
    "name_zh_hk": "富良野、旭川、TOMAMU",
    "name_zh_cn": "富良野、旭川、TOMAMU"
  },
  {
    "code": "towadahachimantai",
    "kml": null,
    "name_ja": "十和田八幡平",
    "name_en": "十和田八幡平",
    "name_zh_tw": "十和田八幡平",
    "name_zh_hk": "十和田八幡平",
    "name_zh_cn": "十和田八幡平"
  },
  {
    "code": "zao",
    "kml": null,
    "name_ja": "蔵王",
    "name_en": "蔵王",
    "name_zh_tw": "藏王",
    "name_zh_hk": "藏王",
    "name_zh_cn": "藏王"
  },
  {
    "code": "aizu-kogen",
    "kml": null,
    "name_ja": "会津高原",
    "name_en": "会津高原",
    "name_zh_tw": "會津高原",
    "name_zh_hk": "會津高原",
    "name_zh_cn": "会津高原"
  },
  {
    "code": "bandaisan",
    "kml": null,
    "name_ja": "磐梯山周辺",
    "name_en": "磐梯山周辺",
    "name_zh_tw": "磐梯山周邊",
    "name_zh_hk": "磐梯山周邊",
    "name_zh_cn": "磐梯山周边"
  },
  {
    "code": "minakami_oze",
    "kml": null,
    "name_ja": "水上・尾瀬・沼田",
    "name_en": "水上・尾瀬・沼田",
    "name_zh_tw": "水上、尾瀬、沼田",
    "name_zh_hk": "水上、尾瀬、沼田",
    "name_zh_cn": "水上、尾瀬"
  },
  {
    "code": "karuizawa_sugadaira",
    "kml": null,
    "name_ja": "軽井沢・菅平",
    "name_en": "軽井沢・菅平",
    "name_zh_tw": "輕井澤、菅平",
    "name_zh_hk": "輕井澤、菅平",
    "name_zh_cn": "轻井泽、菅平"
  },
  {
    "code": "kusatsu_manza",
    "kml": null,
    "name_ja": "草津・万座",
    "name_en": "草津・万座",
    "name_zh_tw": "草津、萬座",
    "name_zh_hk": "草津、萬座",
    "name_zh_cn": "草津、万座"
  },
  {
    "code": "yuzawa_naeba_muikamachi",
    "kml": null,
    "name_ja": "湯沢・苗場・六日町",
    "name_en": "湯沢・苗場・六日町",
    "name_zh_tw": "湯澤、苗場、六日町",
    "name_zh_hk": "湯澤、苗場、六日町",
    "name_zh_cn": "汤泽、苗场、六日町"
  },
  {
    "code": "myoko_akakura_arai",
    "kml": null,
    "name_ja": "妙高・赤倉・新井",
    "name_en": "妙高・赤倉・新井",
    "name_zh_tw": "妙高、赤倉、新井",
    "name_zh_hk": "妙高、赤倉、新井",
    "name_zh_cn": "妙高、赤仓、新井"
  },
  {
    "code": "shiga_nozawaonsen_madarao_iiduna",
    "kml": null,
    "name_ja": "志賀・野沢・斑尾・飯綱",
    "name_en": "志賀・野沢・斑尾・飯綱",
    "name_zh_tw": "志賀、野澤、斑尾、飯綱",
    "name_zh_hk": "志賀、野澤、斑尾、飯綱",
    "name_zh_cn": "志贺、野泽、斑尾、饭纲"
  },
  {
    "code": "tateshina_yatsugatake",
    "kml": null,
    "name_ja": "蓼科・八ヶ岳",
    "name_en": "蓼科・八ヶ岳",
    "name_zh_tw": "蓼科、八岳",
    "name_zh_hk": "蓼科、八岳",
    "name_zh_cn": "蓼科、八岳"
  },
  {
    "code": "hakuba",
    "kml": null,
    "name_ja": "白馬",
    "name_en": "白馬",
    "name_zh_tw": "白馬",
    "name_zh_hk": "白馬",
    "name_zh_cn": "白马"
  },
  {
    "code": "norikura_ontake_ina",
    "kml": null,
    "name_ja": "乗鞍・御岳・伊那",
    "name_en": "乗鞍・御岳・伊那",
    "name_zh_tw": "乗鞍、御岳、伊那",
    "name_zh_hk": "乗鞍、御岳、伊那",
    "name_zh_cn": "乗鞍、御岳、伊那"
  },
  {
    "code": "shiratori",
    "kml": null,
    "name_ja": "白鳥",
    "name_en": "白鳥",
    "name_zh_tw": "白鳥",
    "name_zh_hk": "白鳥",
    "name_zh_cn": "白鸟"
  },
  {
    "code": "lake-biwa",
    "kml": null,
    "name_ja": "琵琶湖",
    "name_en": "琵琶湖",
    "name_zh_tw": "琵琶湖",
    "name_zh_hk": "琵琶湖",
    "name_zh_cn": "琵琶湖"
  }
];

export default fixedDataAreas;
